// App-specific config

// Using CommonJS instead of ES2015+ export, because we also need to
// provide this object to Webpack in vue.config.js.
module.exports = {
  title: 'Texas OnCourse',
  description:
    'The purpose of this data visualization widget is to allow the End-User Group to better understand the high school, college, and career outcomes of their students in order to evaluate and improve their advising practice.',
}
